import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud } from "react-icons/fi";
import { toast } from "react-toastify";

const AddUserForm = ({
  initialData = null,
  onSubmit,
  onCancel,
  requireImage = true,
}) => {
  const [form, setForm] = useState({
    title: "",
    position: "",
    description: "",
    active: true,
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        position: initialData.position || "",
        description: initialData.description || "",
        active: initialData.active ?? true,
      });
      setPreview(initialData.imageUrl || null);
      setImage(null);
    } else {
      setForm({ title: "", position: "", description: "", active: true });
      setImage(null);
      setPreview(null);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const removeImage = () => {
    setImage(null);
    setPreview(null);
  };

  const submit = (e) => {
    e.preventDefault();

    // Faqat yangi qo'shishda rasm majburiy
    if (requireImage && !image && !preview) {
      toast.error("Rasm yuklash majburiy!");
      return;
    }

    onSubmit({ ...form, image });
  };

  return (
    <motion.form
      onSubmit={submit}
      className="banner-form"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="form-grid">
        <div className="form-item">
          <label>Ism Familya *</label>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-item">
          <label>Lavozimi *</label>
          <input
            name="position"
            value={form.position}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-item">
          <label>Holati</label>
          <div className="toggle">
            <input
              type="checkbox"
              id="active"
              name="active"
              checked={form.active}
              onChange={handleChange}
            />
            <label htmlFor="active" className="toggle-label" />
            <span style={{ marginLeft: 12 }}>
              {form.active ? "Faol" : "Faol emas"}
            </span>
          </div>
        </div>

        <div className="form-item">
          <label>Rasm {requireImage ? "*" : "(ixtiyoriy)"}</label>
          <div className="image-upload-box">
            {preview ? (
              <div className="image-preview-wrapper">
                <img
                  src={preview}
                  alt="Tanlangan rasm"
                  className="image-preview-small"
                />
                <motion.button
                  type="button"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="remove-image-btn"
                  onClick={removeImage}
                  title="Rasmni o‘chirish"
                >
                  ×
                </motion.button>
              </div>
            ) : (
              <motion.label
                htmlFor="imgInput"
                className="upload-area"
                whileHover={{ scale: 1.02, backgroundColor: "#f0f7ff" }}
                whileTap={{ scale: 0.98 }}
              >
                <FiUploadCloud size={36} color="#00c853" />
                <p>Rasm tanlash</p>
                <span>JPG, PNG • Maks 5MB</span>
              </motion.label>
            )}
            <input
              id="imgInput"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImage}
            />
          </div>
        </div>

        <div className="form-item full-width">
          <label>Bio (ixtiyoriy)</label>
          <textarea
            name="description"
            rows="4"
            value={form.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-buttons">
          <button type="submit" className="save">
            Saqlash
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default AddUserForm;
